// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Trs1","footer":"ReportModalFilter_footer__3PAf9"};